export const FONT_FAMILY_OPTIONS = [
    { value: "sans-serif", label: "Default" },
    { value: "Arial", label: "Arial" },
    { value: "Calibri", label: "Calibri" },
    { value: "Comic Sans MS", label: "Comic Sans" },
    { value: "Courier New", label: "Courier New" },
    { value: "Georgia", label: "Georgia" },
    { value: "Rubik", label: "Rubik" },
    { value: "Times New Roman", label: "Times New Roman" },
    { value: "Verdana", label: "Verdana" },
];
export const TEXT_COLOUR_SWATCHES = {
    "Black": "#000000",
    "Red": "#FF3B2D",
    "Blue": "#4353EB",
    "Green": "#43882E",
};
export const DEMO_COLOUR_SWATCHES = Object.assign({}, TEXT_COLOUR_SWATCHES);
